<script lang="ts">
  import EmailForm from "@onboarding2/svelte/Signup/EmailForm.svelte";
  import PageWrapper from "@onboarding2/svelte/Signup/PageWrapper.svelte";
  import type { UserInfo, UserSignUp } from "@shared/types/User";

  export let user: UserSignUp;
  export let userInfo: UserInfo;

</script>

<PageWrapper {user} {userInfo}>
  <EmailForm />
</PageWrapper>
